module.exports = __webpack_public_path__ + "static/media/banner_studyHacker.c067b13f.svg";